import { useContext, useEffect } from 'react';
import { SubscriptionContext } from '../../../../contextApi/SubscriptionContext';
import Payment from './Payment';

export default function PaymentForm() {
  const {setProgressState, paymentMessage} = useContext(SubscriptionContext);
  useEffect(()=>{setProgressState(3)},[])

  return (
    <div className='paymentForm'>
      <h1>עמוד התשלום</h1>
      <Payment/>

      {paymentMessage === "האימייל כבר רשום במערכת, למעבר לעמוד התחברות לחץ - " ? 
      <div style={{color:"red"}}>{paymentMessage}<a href='/webingo/signin' dir='rtl'>כאן</a></div> :
      <div style={{color:"red"}}>{paymentMessage}</div>}
    </div>
  )
}
